// extracted by mini-css-extract-plugin
export default {"tooltip":"xW-z","arrow":"yW-z"};